export default __webpack_public_path__ + "static/media/white-nav-left.51689230.svg";